import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Close16 from '@carbon/icons-react/es/close/16';
import styled from 'styled-components';
import { BodyShort01, Text02 } from 'components/styles';
import { ProductiveHeading03, BodyShort01 as OzoneBodyShort01, TextWrapper } from 'components/atoms/typography';
import { Drawer as DrawerAtom } from './drawer';
export const CustomLayoutDrawer = styled(DrawerAtom)`
  .ant-drawer-header {
    padding: 0;
  }

  .ant-drawer-close {
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
  }
  .ant-drawer-body {
    padding: 0;
  }
`;
const Divider = styled.div`
  border-top: 1px solid var(--border-color);
`;
const Separator = styled.div`
  margin: 0 var(--spacing-02);

  &::after {
    content: '·';
  }
`;
const Text = styled(TextWrapper)`
  padding: 0;
`;
const TitleDescription = styled.div`
  ${BodyShort01};
  color: var(--gray-50);
`;
const Title = styled(ProductiveHeading03).attrs({
    as: Text
})``;
const TitleWithDescription = ({ title, description, children, className, ...props })=>{
    return /*#__PURE__*/ _jsx(Title, {
        className: className,
        ...props,
        children: children != null ? children : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                title,
                description != null ? /*#__PURE__*/ _jsx(TitleDescription, {
                    children: description
                }) : null
            ]
        })
    });
};
const StyledTitle = styled(TitleWithDescription)``;
const DrawerTitle = StyledTitle;
DrawerTitle.Title = Title;
DrawerTitle.Description = TitleDescription;
const Content = styled(OzoneBodyShort01)``;
const Footer = styled.div``;
const DrawerComponent = styled.div`
  --popover-spacing: var(--spacing-05);
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
  height: 100%;

  ${Title} {
    padding: var(--popover-spacing) var(--popover-spacing)
      var(--popover-spacing);
    background: var(--coolest-gray-10);
    flex: 0 0 auto;
  }

  ${Content} {
    padding: var(--popover-spacing) var(--popover-spacing)
      calc(2 * var(--popover-spacing));
    flex: 1;
    overflow-y: auto;
  }

  ${Footer} {
    border-top: 1px solid var(--border-color);
    flex: 0 0 auto;
    padding: var(--popover-spacing);
  }

  ${Divider} {
    margin-top: var(--popover-spacing);
  }
`;
const HelpText = styled.div`
  ${Text02};
  padding: 8px 10px 10px 0;
  font-size: 14px;
  line-height: 1; /* Matches the font size exactly */

  a {
    margin-left: var(--spacing-02);
    font-size: 14px;
    padding: 8px 10px 10px 0;
    line-height: 1; /* Matches the font size exactly */
  }
`;
const CustomLayoutDrawerContent = DrawerComponent;
CustomLayoutDrawerContent.Title = DrawerTitle;
CustomLayoutDrawerContent.Content = Content;
CustomLayoutDrawerContent.Divider = Divider;
CustomLayoutDrawerContent.Separator = Separator;
CustomLayoutDrawerContent.Footer = Footer;
CustomLayoutDrawerContent.TitleHelpText = HelpText;
export { CustomLayoutDrawerContent };
export const DefaultCustomLayoutDrawerProps = {
    placement: 'right',
    closable: true,
    closeIcon: /*#__PURE__*/ _jsx(Close16, {
        "data-cy": "aifills.template.close.icon"
    }),
    mask: true,
    destroyOnClose: true
};
